import { useEffect } from 'react';
import { configuration } from 'apis';

const normalizeProductServiceItem = (item) => ({
    ...item,
    id: item.id ?? item.Id,
    description: item.description ?? item.Description ?? '',
    abbr: item.abbr ?? item.Abbr ?? '',
    position: item.position ?? item.Position ?? 0,
    unitPrice: item.unitPrice ?? item.UnitPrice ?? 0,
    vatPerc: item.vatPerc ?? item.VatPerc ?? 0,
    dataKey: item.dataKey ?? item.DataKey ?? '',
    hasSeason: item.hasSeason ?? item.HasSeason ?? false,
    isActive: item.isActive ?? item.IsActive ?? true,
    pfeTypeId: item.pfeTypeId ?? item.PFETypeId ?? null,
    isPayment: item.isPayment ?? item.IsPayment ?? false,
    code: item.code ?? item.Code ?? '',
    parentID: item.parentID ?? item.ParentID ?? null,
    isUniquePerEntity: item.isUniquePerEntity ?? item.IsUniquePerEntity ?? false,
    isDefault: item.isDefault ?? item.IsDefault ?? false,
    isNew: item.isNew ?? false,
    isDeleted: item.isDeleted ?? false
});

const useChecklistInitialLists = ({
    setQuestionTypes,
    setProductServicesList,
    setTransactionTypesList,
    setApplicationStatuses,
    setPersonStatuses,
    setAuditStatuses,
    setPfeTypes,
    setLkCommonParents,
    setDisciplines
}) => {
    useEffect(() => {
        const fetchQuestionTypes = async () => {
            try {
                const res = await configuration.getQuestionTypes();
                if (Array.isArray(res)) {
                    setQuestionTypes(res);
                }
            } catch (err) {
                console.error('Failed to load question types', err);
            }
        };

        fetchQuestionTypes();
    }, [setQuestionTypes]);

    useEffect(() => {
        const fetchTransactionTypes = async () => {
            try {
                const res = await configuration.getTransactionTypes();
                setTransactionTypesList(res);
            } catch (err) {
                console.error('Failed to fetch transaction types', err);
            }
        };

        fetchTransactionTypes();
    }, [setTransactionTypesList]);

    useEffect(() => {
        const fetchApplicationStatuses = async () => {
            try {
                const res = await configuration.getStatuses('Applications');
                setApplicationStatuses(Array.isArray(res) ? res : []);
            } catch (err) {
                console.error('Failed to fetch application statuses', err);
            }
        };

        fetchApplicationStatuses();
    }, [setApplicationStatuses]);

    useEffect(() => {
        const fetchPersonStatuses = async () => {
            try {
                const res = await configuration.getStatuses('Person');
                setPersonStatuses(Array.isArray(res) ? res : []);
            } catch (err) {
                console.error('Failed to fetch person statuses', err);
            }
        };

        fetchPersonStatuses();
    }, [setPersonStatuses]);

    useEffect(() => {
        const fetchAuditStatuses = async () => {
            try {
                const res = await configuration.getAuditStatuses();
                setAuditStatuses(Array.isArray(res) ? res : []);
            } catch (err) {
                console.error('Failed to fetch audit statuses', err);
            }
        };

        fetchAuditStatuses();
    }, [setAuditStatuses]);

    useEffect(() => {
        const fetchPfeTypes = async () => {
            try {
                const res = await configuration.getPfeTypes();
                setPfeTypes(Array.isArray(res) ? res : []);
            } catch (err) {
                console.error('Failed to fetch PFE types', err);
            }
        };

        fetchPfeTypes();
    }, [setPfeTypes]);

    useEffect(() => {
        const fetchLkCommonParents = async () => {
            try {
                const res = await configuration.getLkCommonParents();
                setLkCommonParents(Array.isArray(res) ? res : []);
            } catch (err) {
                console.error('Failed to fetch LK common parents', err);
            }
        };

        fetchLkCommonParents();
    }, [setLkCommonParents]);

    useEffect(() => {
        const fetchDisciplines = async () => {
            try {
                const res = await configuration.getDisciplines();
                if (Array.isArray(res)) {
                    setDisciplines(res);
                }
            } catch (err) {
                console.error('Failed to load disciplines:', err);
            }
        };

        fetchDisciplines();
    }, [setDisciplines]);

    useEffect(() => {
        const fetchData = async () => {
            const data = await configuration.getProductServices();
            setProductServicesList(Array.isArray(data) ? data.map(normalizeProductServiceItem) : []);
        };

        fetchData();
    }, [setProductServicesList]);
};

export default useChecklistInitialLists;
